<div class="footer">
  <p>Powered By LYNNCO Version 3.2</p>
</div>
